import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 12l16 0","key":"svg-0"}],["path",{"d":"M8 8l4 -4l4 4","key":"svg-1"}],["path",{"d":"M16 16l-4 4l-4 -4","key":"svg-2"}]]

const IconSeparatorHorizontal = createReactComponent('outline', 'separator-horizontal', 'SeparatorHorizontal', __iconNode);

export default IconSeparatorHorizontal;